export default "__VITE_ASSET__DVOzA6VD__"